import { toast } from 'react-hot-toast'

interface ErrorWithToastFlag {
  _toastShown?: boolean
}

/** Mark an error as having already triggered a toast notification */
export const markToastShown = (error: unknown): void => {
  if (error && typeof error === 'object') {
    (error as ErrorWithToastFlag)._toastShown = true
  }
}

/** Check whether a toast was already shown for this error */
export const isToastShown = (error: unknown): boolean => {
  return !!(error && typeof error === 'object' && (error as ErrorWithToastFlag)._toastShown)
}

/**
 * Show an error toast only if the interceptor hasn't already shown one.
 * Use this in component catch blocks instead of toast.error() to prevent duplicates.
 */
export const showErrorToast = (error: unknown, fallbackMessage: string): void => {
  if (!isToastShown(error)) {
    toast.error(fallbackMessage)
  }
}
